import dayjs from 'dayjs'
import {CalendarView} from 'types/enums/CalendarView'

export const getNewDateObject = (date: Date, preset: CalendarView | null, offset: number | null) => {
    const safeOffset = offset ?? 0
    if (preset === CalendarView.Day || preset === CalendarView.Agenda) {
        date.setDate(date.getDate() + safeOffset)
    } else if (preset === CalendarView.Week) {
        date.setDate(date.getDate() + safeOffset * 7)
    } else if (preset === CalendarView.Month || preset === CalendarView.Year) {
        // Clamp the day to the destination month instead of overflowing into the next one.
        date.setTime(dayjs(date).add(safeOffset, preset === CalendarView.Month ? 'month' : 'year').valueOf())
    }

    return {year: date.getFullYear(), month: date.getMonth() + 1, day: date.getDate()}
}
